/* eslint-disable import/prefer-default-export */

import { EventPanelActions } from '../../constants';

// Event Panel content is updated
export const updateEventContent = (eventContent) => ({
  type: EventPanelActions.UPDATE_EVENT_CONTENT,
  eventContent,
});
